import { render } from "./commodity.vue?vue&type=template&id=34ccfe9c&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"

import "./commodity.vue?vue&type=style&index=0&id=34ccfe9c&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ccfe9c"]])

export default __exports__